import Vue from 'vue'
import Vuex from 'vuex'
import {
	getAPPInfo
} from "../api/index.js"
// import {
// 	convertCenttoYuan
// } from '../utils/utils.js'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: localStorage.getItem("user")||'',
		app_info:{
			
		}
	},
	mutations: {
		setUser(state, user) {
			state.user = user;
		},
		setAppInfo(state, app_info) {
			state.app_info = app_info;
		},
		setAppElePrice(state,ele_price){
			state.app_info.ele_price = ele_price;
		},
		setAppClothesPrice(state,clothes_price){
			state.app_info.clothes_price = clothes_price;
		}
	},
	actions: {
		getAppInfoFromServer({state,commit}){
			return new Promise((resolve, reject) => {
			let {user} = state;
				getAPPInfo({email:user}).then(res=>{
					if(res.data.code==200){
						if(res.data.web_app_list.length==0){
							resolve("N")
						}else{
							commit("setAppInfo",res.data.web_app_list[0])
							resolve("Y")
						}
					}else{
						reject(res)
					}
				}).catch(err=>{
					reject(err)
				})
			})
		}
	},
	modules: {}
})
